import { PlusStatus } from '@browsing/plus';
import { LoyaltyProgramSummaryResponse } from '@pegasus/plus';
import { FashionPreferences } from './fashion-preferences';

export type CustomerRole = 'guest' | 'welcome' | 'user' | 'doi' | 'offline' | 'soft_user';

/**
 * Customer groups/segments from API.
 * Known fields: lounge_visitor_activity_segments
 * Additional fields may be added from API response
 */
export enum LoungVisitorActivitySegments {
    DAILY = 'daily',
}

export type LoungeCustomerGroups = {
    lounge_visitor_activity_segments?: LoungVisitorActivitySegments;
} & Record<string, string>;
export interface CustomerData {
    birthday: number;
    email: string;
    firstName: string;
    gender: string;
    lastName: string;
    newsletterSubscription: boolean;
    phone: string;
    hashedCustomerNumber: string;
    customerNumber: string;
    tncConfirmed: boolean;
    mailConfirmed: boolean;
    role: CustomerRole;
    registrationDate: number;
    registration_occurred: boolean;
    counted_customer_orders: number;
    preferred_country: string;

    acr: string;
    areCredentialsCompromised: boolean;

    checksum?: string;
    emailProvider?: string;
    isSoftLogin?: boolean;

    plus_status?: PlusStatus;

    loyalty?: LoyaltyProgramSummaryResponse;

    onboarded_at?: string;
    fashion_preferences?: FashionPreferences;
    customerGroups?: LoungeCustomerGroups;
}
